export default __webpack_public_path__ + "static/media/product-3.fa172c81.jpg";